import Vue from 'vue'

export async function getEstados(context, [access_token]) {
    try {
        if (access_token) {
            context.commit('setLoading', true, { root: true })
            const response = await Vue.axios({
                method: 'GET',
                url: '/estados',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
            context.commit('estados/setEstados', response.data, { root: true })
        }

    } catch (e) {
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}


